import React, { useEffect } from 'react';
import { EmptyState } from '../../../../../components/EmptyState';
import { BackToCareersPageButton } from '../BackToCareersPageButton';
import WomanSuccess from '../../../../../images/woman-success-yellow-bg.svg';
import ahoy from 'ahoy.js';
import { CareerAnalyticsEventType } from '../../../../../enums/ClickEvents/CareerAnalyticsEventType';

interface PropTypes {
  organizationId: number;
  jobPostId: number;
  jobPostName: string;
  atsCaptureEventsAhoy: boolean;
  atsDuplicateApplicationEmail: boolean;
}

function DuplicateApplicationtext(props: {
  atsDuplicateApplicationEmail: boolean;
}) {
  if (props.atsDuplicateApplicationEmail) {
    return (
      <div className='text-dark-200 mt-3 fs-5'>
        Please note, if you have previously applied for this role, your
        application status remains unchanged. A hiring member will be notified
        of your re-application.
      </div>
    );
  }

  return (
    <div className='text-dark-200 mt-3 fs-5'>
      Please note, if you have previously applied for this role and not been
      successful, your application will not be reviewed.
    </div>
  );
}

export default function SuccessPage(props: PropTypes) {
  useEffect(() => {
    if (props.atsCaptureEventsAhoy) {
      ahoy.track(CareerAnalyticsEventType.ApplicationSuccessView, {
        organization_id: props.organizationId,
        applicant_tracking_job_post_id: props.jobPostId,
      });
    }
  }, []);

  return (
    <EmptyState
      title={'Your application has been submitted'}
      isResponsive
      text={
        <div>
          Thank you for applying to {props.jobPostName} role. Our team will be
          in touch shortly.
          <DuplicateApplicationtext
            atsDuplicateApplicationEmail={props.atsDuplicateApplicationEmail}
          />
        </div>
      }
      cardless
      imageSrc={WomanSuccess}
      actionButton={
        <BackToCareersPageButton
          color={'primary'}
          size={'md'}
          className={'mt-4'}
          isResponsive
          onClick={() => (window.location.href = '../../..')}
        />
      }
    />
  );
}
